export const errorConstants = {
    tripRuleForbidden: "TRIP_RULE_FORBIDDEN",
    LAST_LEG_EXCEPTION: "LAST_LEG_EXCEPTION",
    CONFIRMED_TRIP: "CONFIRMED_TRIP",
    ON_TRIP_LEG_COMBINATION_EXCEPTION: "ON_TRIP_LEG_COMBINATION_EXCEPTION",
}